import { Card, Col, Row } from "antd";
import type { Event } from "../../../types/events";
import spacing from "../../../components/ui/spacingConfig";
import StatusBadges from "../../../components/tables/StatusBadges";
import AttachmentPreview from "../../../components/ui/AttachmentPreview";

type Props = {
  eventData: Event | undefined;
  className?: string;
};

const CardDescription: React.FC<Props> = ({ eventData, className }) => {
  return (
    <Card title="Description" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Statut</p>
        </Col>
        <Col span={spacing.s}>
          <p>
            {eventData?.statut ? (
              <StatusBadges value={eventData?.statut} type="events" />
            ) : (
              "Not found"
            )}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Titre</p>
        </Col>
        <Col span={spacing.s}>
          <p>{eventData?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Description</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{eventData?.description}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Mesure ImmÃ©diate</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-small-size">{eventData?.firstMeasure}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">Auteur</p>
        </Col>
        <Col span={spacing.s}>
          <p className="text-light-blue">{eventData?.creator?.fullname}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xxxs}>
          <p className="text-light-grey">PiÃ¨ces jointes</p>
        </Col>
        <Col span={spacing.s}>
          <div className="attachments-container">
            {eventData?.attachedFiles.map((file) => (
              <AttachmentPreview key={file.id} fileUrl={file.file} />
            ))}
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDescription;
